module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAwCAYAAABwrHhvAAAAAXNSR0IArs4c6QAAAI5JREFUWEftmEEKgDAMBO0rRX+WDyi+UkHQiwcnIKaH6XlJNxO2gbaI2IfC07oxMM3jrxzWZTvvuwloQAISkIAEJNA9gWt70ZX51lB6G5YboJ1TXZoALUx1GpBAmkB5DMsN0HhRXXoEtDDVaUACaQLlMSw3QONFdekR0MJUpwEJSEACEngQoE/o17ry3/IDUb4cICJFbXwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/滑块@2x.png
// module id = qNx6
// module chunks = 96